module.exports = __webpack_public_path__ + "img/role.9cf828f8.svg";